import LockIcon from "@mui/icons-material/Lock";
import { Box, Stack, Typography } from "@mui/material";

import { CarrierUpgradeNowButton } from "components/Carrier/components/CarrierUpgradeNowButton";
import { getQuoteScoreLevelStyle } from "components/QuoteScore";
import { CarrierUpgradeSource } from "constants/index";

const CONTENT_INSET = "12px";

// The verdict shown behind the blur. Fixed on purpose, and never the
// carrier's real one: blur is a visual effect, not encryption, and the text
// is still sitting in the DOM.
const PLACEHOLDER_STYLE = getQuoteScoreLevelStyle("competitive");

/**
 * The gated variant of QuoteScoreStrip for a carrier below Bronze
 * (docs/engineering/design/quote_competitiveness_scoring_design.md §14) — driven
 * directly by the API's own `{ gated: true }` response, not re-derived from
 * subscription status client-side.
 */
export function QuoteScoreLocked() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        width: "100%",
        pl: CONTENT_INSET,
        pr: 1.5,
        py: 1,
        backgroundColor: "grey.50",
        border: "1px solid",
        borderColor: "divider",
        borderLeft: "4px solid",
        borderLeftColor: "grey.300",
        borderRadius: "4px",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <LockIcon
          sx={{ fontSize: 20, color: "text.secondary", flexShrink: 0 }}
        />

        <Box
          aria-hidden="true"
          sx={{
            filter: "blur(5px)",
            opacity: 0.4,
            pointerEvents: "none",
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: "9px",
                height: "9px",
                borderRadius: "50%",
                backgroundColor: PLACEHOLDER_STYLE.color,
              }}
            />
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                color: PLACEHOLDER_STYLE.color,
                whiteSpace: "nowrap",
              }}
            >
              {PLACEHOLDER_STYLE.label}
            </Typography>
          </Stack>
        </Box>
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ ml: "auto", flexShrink: 0 }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "text.primary",
            whiteSpace: "nowrap",
          }}
        >
          See how your quote compares
        </Typography>
        <CarrierUpgradeNowButton
          upgradeSource={CarrierUpgradeSource.QUOTE_SCORE}
          size="small"
        />
      </Stack>
    </Box>
  );
}
